// Rótulos de valores que vêm da Meta (qualidade, limite de envio). Usados na
// tela de Números e no painel do oficial. O mapa é explícito: valor desconhecido
// aparece cru, em vez de virar uma chave de tradução na tela.

type T = (k: string, v?: Record<string, string | number>) => string;

export const QUALITY = ['GREEN', 'YELLOW', 'RED'] as const;

export function metaLabel(
  t: (k: string) => string,
  known: readonly string[],
  prefix: string,
  value?: string,
): string {
  if (!value) return '—';
  return known.includes(value) ? t(`${prefix}.${value}`) : value;
}

/**
 * Limite de envio em linguagem de gente: "TIER_250" vira "250 contatos novos por
 * dia". O cliente não deveria precisar aprender o vocabulário da Meta para saber
 * quanto pode enviar.
 */
export function limitLabel(t: T, value?: string): string {
  if (!value) return '—';
  if (/UNLIMITED/i.test(value)) return t('official.limitUnlimited');
  const m = /^TIER_(\d+)(K?)$/i.exec(value);
  if (!m) return value;
  const n = Number(m[1]) * (m[2] ? 1000 : 1);
  return t('official.limitValue', { n: n.toLocaleString() });
}
